import type { ConfigurationPackage } from '@festina/configuration-general-types/configuration'
import { STANDARD_BRANCH } from '@festina-life/api'
import type { ConfigurableServer, Optional } from '@festina-life/core'
import { useMutation } from '@tanstack/react-query'

import { ServerServices } from '../../openApiServices'

type Props = {
  server: ConfigurableServer
  branchName?: Optional<string>
  shouldIncludeBaseChangesets: boolean
  shouldIncludeExtrinsicParameterValues: boolean
  squash?: boolean
  block: string
}

export const useLazyFetchBulkConfigurationPackage = () =>
  useMutation({
    mutationFn: async ({
      server,
      branchName,
      shouldIncludeBaseChangesets,
      shouldIncludeExtrinsicParameterValues,
      squash,
      block,
    }: Props): Promise<Optional<ConfigurationPackage>> => {
      if (!server || !ServerServices[server]) {
        throw new Error(`Unknown server: ${server}`)
      }

      if (!branchName) {
        return Promise.resolve(null)
      }

      const params = {
        componentName: server.toLocaleLowerCase(),
        branchName,
        includeBaseChangesets: shouldIncludeBaseChangesets,
        skipLargeOperationTranslation: false,
        shouldIncludeExtrinsicParameterValues,
        squash,
        block,
      }

      return await (branchName !== STANDARD_BRANCH
        ? ServerServices.configuration.api.ConfigurationRepositoryBranchesService.branchServiceGetGetBranchChangesets(
            params,
          )
        : ServerServices[
            server
          ].api.ConfigurationRepositoryBranchesService.configurationServiceGetGetBulkChangesets(
            params,
          ))
    },
  })
